'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Actions = require('../../Actions');

var _Actions2 = _interopRequireDefault(_Actions);

var _Api = require('../../utils/Api');

var _Api2 = _interopRequireDefault(_Api);

var _parse = require('parse');

var _parse2 = _interopRequireDefault(_parse);

var _Utility = require('../../utils/Utility');

var Utils = _interopRequireWildcard(_Utility);

var _CartStore = require('../../stores/CartStore');

var _CartStore2 = _interopRequireDefault(_CartStore);

var _SimpleButton = require('../generic/SimpleButton');

var _SimpleButton2 = _interopRequireDefault(_SimpleButton);

var _SpinButton = require('../generic/SpinButton');

var _SpinButton2 = _interopRequireDefault(_SpinButton);

var _Constants = require('../Constants');

var Constants = _interopRequireWildcard(_Constants);

var _MainStore = require('../../stores/MainStore');

var _MainStore2 = _interopRequireDefault(_MainStore);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CouponHolder = function (_React$Component) {
    _inherits(CouponHolder, _React$Component);

    function CouponHolder(props) {
        _classCallCheck(this, CouponHolder);

        var _this = _possibleConstructorReturn(this, (CouponHolder.__proto__ || Object.getPrototypeOf(CouponHolder)).call(this, props));

        _this.applyCoupon = function () {

            var isGuest = false;
            var couponCode = _this.couponCode.value;
            _this.couponCode.value = "";
            var userDetailPtrId = null;
            var sessionToken = null;
            var router = _this.props.router;
            var locId = _this.props.locId;

            _this.setState({ isLoading: true });

            var currentUser = _parse2.default.User.current();
            if (!Utils.isEmptyObj(currentUser)) {
                isGuest = false;
                userDetailPtrId = currentUser.id;
                sessionToken = currentUser.getSessionToken();
            } else {
                isGuest = true;
            }

            if (!couponCode) {
                _this.setState({
                    success: false,
                    error: true,
                    errorMessage: "Please Enter Coupon Code",
                    isLoading: false
                });
                return;
            }

            _Api2.default.applyCoupon(isGuest, sessionToken, userDetailPtrId, _this.props.bizId, _this.props.locId, couponCode, _this.props.subTotal).then(function (res) {
                if (res.data && res.data.isCouponValid) {
                    _this.setState({
                        success: true,
                        error: false,
                        couponCode: couponCode,
                        isLoading: false
                    }, function () {
                        _Actions2.default.applyCoupon(res.data.percentOff, res.data.amountOff, couponCode);
                    });
                }
            }).then(function () {
                Constants.scrollToTop('price-table');
            }, function (errorResponse) {
                // check the error and alert the invalid session token
                Utils.checkErrorIsInvalidSessionToken(errorResponse, router, locId, false);
                var errorMessage = "Some error occurred while coupon application!";
                if (errorResponse) {
                    errorMessage = errorResponse.responseJSON.error.message;
                    console.log(JSON.stringify(errorResponse.responseJSON));
                }
                _this.setState({
                    success: false,
                    error: true,
                    errorMessage: errorMessage,
                    isLoading: false
                }, function () {
                    Constants.scrollToTop('coupon-err');
                });
            });

            // this.setState({ isLoading : false })
        };

        _this.removeCoupon = function () {
            _this.setState({
                couponCode: "",
                success: false
            }, function () {
                _Actions2.default.applyCoupon(null, null, null);
            });
        };

        _this.handleCouponChange = function () {
            _this.setState({
                error: null
            });
        };

        _this.state = {
            error: null,
            success: null,
            isLoading: false
        };
        return _this;
    }

    _createClass(CouponHolder, [{
        key: 'UNSAFE_componentWillMount',
        value: function UNSAFE_componentWillMount() {
            if (this.props.isCouponApplied) {
                this.setState({
                    success: true,
                    couponCode: this.props.couponCode
                });
            } else {
                this.setState({
                    success: null
                });
            }
        }
    }, {
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
            if (nextProps.isCouponApplied) {
                this.setState({
                    success: true,
                    couponCode: nextProps.couponCode
                });
            } else {
                this.setState({
                    success: null
                });
            }

            //remove error message when user loggedIn.
            if (nextProps.isLoggedInExistingUser) {
                this.setState({
                    error: false,
                    errorMessage: ""
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                { className: 'mb-3 clearfix mt-2' },
                _react2.default.createElement(
                    'label',
                    { htmlFor: 'coupon-input', className: 'ft-14' },
                    'Apply Coupon Code'
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'input-group input-group-sm mb-2' },
                    _react2.default.createElement('input', {
                        id: 'coupon-input',
                        type: 'text',
                        className: 'form-control',
                        placeholder: 'Enter promo code',
                        ref: function ref(input) {
                            return _this2.couponCode = input;
                        },
                        onChange: this.handleCouponChange,
                        tabIndex: 40
                    }),
                    _react2.default.createElement(
                        'div',
                        { className: 'input-group-append' },
                        _react2.default.createElement(_SpinButton2.default, {
                            classNames: 'btn btn-sm btn-styl font-weight-bold ' + (this.state.success ? "coupon-btn-disabled" : ""),
                            buttonText: 'APPLY',
                            spinText: "Applying.. ",
                            showSpinner: this.state.isLoading,
                            whenClicked: this.applyCoupon,
                            showIcon: true,
                            iconClass: "icofont-sale-discount mr-1",
                            tabIndex: 41
                        })
                    )
                ),
                this.state.error ? _react2.default.createElement(
                    'div',
                    { className: 'coupon-error', id: 'coupon-err', 'aria-hidden': 'true' },
                    _react2.default.createElement('i', { className: 'fa fa-times', 'aria-hidden': 'true' }),
                    ' ',
                    this.state.errorMessage
                ) : null,
                this.state.success ? _react2.default.createElement(
                    'div',
                    { className: 'coupon-success', 'aria-hidden': 'true' },
                    _react2.default.createElement('i', { className: 'fa fa-check-circle', 'aria-hidden': 'true' }),
                    ' Coupon ',
                    _react2.default.createElement(
                        'b',
                        { className: 'text-uppercase' },
                        this.state.couponCode
                    ),
                    ' applied successfully.',
                    _react2.default.createElement(
                        'span',
                        { style: { marginLeft: "5px" } },
                        _react2.default.createElement(
                            'span',
                            { className: 'text-dark' },
                            '('
                        ),
                        _react2.default.createElement(
                            'a',
                            {
                                className: 'color-red remove-link btn-button-link',
                                onClick: this.removeCoupon
                            },
                            'Remove'
                        ),
                        _react2.default.createElement(
                            'span',
                            { className: 'text-dark', 'aria-hidden': 'true' },
                            ')'
                        )
                    )
                ) : null
            );
        }
    }]);

    return CouponHolder;
}(_react2.default.Component);

exports.default = CouponHolder;


//////////////////
// WEBPACK FOOTER
// ./src/components/coupon/CouponHolder.jsx
// module id = 565
// module chunks = 0